// src/app/mocks/mock-transaction-data.ts
import { Transaction, ApproveStatus, TransactionOverviewDto } from '../models/transaction.model';
import { NotificationDetailDto } from '../models/transaction-detail.model';
import { TransactionItem, ApproveItemStatus } from '../models/item.model';

export class MockTransactionData {
  
  static readonly mockTransactions: Transaction[] = [
    {
      id: 1001,
      title: 'TechStore Praha - IT vybavení',
      message: 'Nákup IT vybavení pro kancelář - notebooky, monitory, klávesnice a další hardware',
      createdAt: '2025-03-22T14:30:00Z',
      status: ApproveStatus.Imported,
      store: 'TechStore Praha'
    },
    {
      id: 1002,
      title: 'Office Supplies s.r.o. - Kancelář',
      message: 'Kancelářské potřeby - papír, tonery, psací potřeby a organizační materiály',
      createdAt: '2025-03-21T11:15:00Z',
      status: ApproveStatus.Finished,
      store: 'Office Supplies s.r.o.'
    },
    {
      id: 1003,
      title: 'AutoServis Novák - Služební vozidla',
      message: 'Servis služebních vozidel - výměna pneumatik, oleje, kontrola a opravy',
      createdAt: '2025-03-20T09:45:00Z',
      status: ApproveStatus.Imported,
      store: 'AutoServis Novák'
    },
    {
      id: 1004,
      title: 'Restaurant U Fleku - Firemní akce',
      message: 'Firemní večeře s klienty - menu, nápoje, servis a reprezentace',
      createdAt: '2025-03-19T19:30:00Z',
      status: ApproveStatus.Finished,
      store: 'Restaurant U Fleku'
    },
    {
      id: 1005,
      title: 'Knihkupectví Academia - Vzdělávání',
      message: 'Odborná literatura a materiály pro školení zaměstnanců a rozvoj',
      createdAt: '2025-03-18T16:20:00Z',
      status: ApproveStatus.Imported,
      store: 'Knihkupectví Academia'
    },
    {
      id: 1006,
      title: 'Hotel Marriott - Služební cesta',
      message: 'Ubytování během služební cesty - 2 noci, snídaně a konferenční služby',
      createdAt: '2025-03-17T22:00:00Z',
      status: ApproveStatus.Finished,
      store: 'Hotel Marriott'
    },
    {
      id: 1007,
      title: 'Benzina - Pohonné hmoty',
      message: 'Tankování služebního vozidla - Natural 95, SPZ: 4A2 3456',
      createdAt: '2025-03-17T07:45:00Z',
      status: ApproveStatus.Imported,
      store: 'Benzina'
    }
  ];

  private static readonly mockTransactionDetails: Record<number, NotificationDetailDto> = {
    1001: {
      NotificationID: 1001, SenderUserID: 1, Title: 'TechStore Praha - IT vybavení',
      Body: 'Nákup IT vybavení pro kancelář - notebooky, monitory, klávesnice a další hardware pro rozšíření týmu',
      ApnsPriority: 10, Type: 0, Status: 0, Created: '2025-03-22T14:30:00Z',
      Transaction: {
        TransactionID: 1001, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Imported, SenderBusinessUnitName: 'TechStore Praha',
        CreatedAt: '2025-03-22T14:30:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2001, foreignItemID: 101, requestNote: 'Potřebujeme výkonný notebook pro nového vývojáře', responseNote: '', quantity: 1, proposedUnitPrice: 28500.00, proposedTotal: 28500.00, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=300&h=200&fit=crop' },
          { itemID: 2002, foreignItemID: 102, requestNote: '4K monitor pro designérské práce', responseNote: '', quantity: 1, proposedUnitPrice: 12900.00, proposedTotal: 12900.00, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=300&h=200&fit=crop' },
          { itemID: 2003, foreignItemID: 103, requestNote: 'Bezdrátové klávesnice pro ergonomii', responseNote: '', quantity: 2, proposedUnitPrice: 2580.50, proposedTotal: 5161.00, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=300&h=200&fit=crop' }
        ]
      }
    },
    1002: {
      NotificationID: 1002, SenderUserID: 1, Title: 'Office Supplies s.r.o. - Kancelář',
      Body: 'Kancelářské potřeby - papír, tonery, psací potřeby a organizační materiály',
      ApnsPriority: 10, Type: 0, Status: 3, Created: '2025-03-21T11:15:00Z',
      Transaction: {
        TransactionID: 1002, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Finished, SenderBusinessUnitName: 'Office Supplies s.r.o.',
        CreatedAt: '2025-03-21T11:15:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2011, foreignItemID: 111, requestNote: 'Zásoby papíru na celý měsíc', responseNote: 'Schváleno - standardní kancelářský papír', quantity: 20, proposedUnitPrice: 145.50, proposedTotal: 2910.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1586075010923-2dd4570fb338?w=300&h=200&fit=crop' },
          { itemID: 2012, foreignItemID: 112, requestNote: 'Náhradní tonery pro tiskárny', responseNote: 'Schváleno - originální HP tonery', quantity: 3, proposedUnitPrice: 3200.00, proposedTotal: 9600.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1612198188060-c7c2a3b66eae?w=300&h=200&fit=crop' }
        ]
      }
    },
    1003: {
      NotificationID: 1003, SenderUserID: 1, Title: 'AutoServis Novák - Služební vozidla',
      Body: 'Servis služebních vozidel - výměna pneumatik, oleje, kontrola a opravy',
      ApnsPriority: 10, Type: 0, Status: 0, Created: '2025-03-20T09:45:00Z',
      Transaction: {
        TransactionID: 1003, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Imported, SenderBusinessUnitName: 'AutoServis Novák',
        CreatedAt: '2025-03-20T09:45:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2021, foreignItemID: 121, requestNote: 'Výměna letních pneumatik - bezpečnost', responseNote: '', quantity: 4, proposedUnitPrice: 4200.00, proposedTotal: 16800.00, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&h=200&fit=crop' },
          { itemID: 2022, foreignItemID: 122, requestNote: 'Pravidelná výměna oleje podle plánu', responseNote: '', quantity: 1, proposedUnitPrice: 2800.00, proposedTotal: 2800.00, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=300&h=200&fit=crop' },
          { itemID: 2023, foreignItemID: 123, requestNote: 'Povinná technická kontrola', responseNote: 'Předschváleno - povinná kontrola', quantity: 1, proposedUnitPrice: 1200.00, proposedTotal: 1200.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1486754735734-325b5831c3ad?w=300&h=200&fit=crop' }
        ]
      }
    },
    1004: {
      NotificationID: 1004, SenderUserID: 1, Title: 'Restaurant U Fleku - Firemní akce',
      Body: 'Firemní večeře s klienty - menu, nápoje, servis a reprezentace',
      ApnsPriority: 10, Type: 0, Status: 3, Created: '2025-03-19T19:30:00Z',
      Transaction: {
        TransactionID: 1004, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Finished, SenderBusinessUnitName: 'Restaurant U Fleku',
        CreatedAt: '2025-03-19T19:30:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2031, foreignItemID: 131, requestNote: 'Degustační menu pro důležité klienty', responseNote: 'Schváleno - reprezentace firmy', quantity: 8, proposedUnitPrice: 680.00, proposedTotal: 5440.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=300&h=200&fit=crop' },
          { itemID: 2032, foreignItemID: 132, requestNote: 'Nápoje k večeři - pivo a víno', responseNote: 'Schváleno - přiměřené množství', quantity: 8, proposedUnitPrice: 320.00, proposedTotal: 2560.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=300&h=200&fit=crop' }
        ]
      }
    },
    1005: {
      NotificationID: 1005, SenderUserID: 1, Title: 'Knihkupectví Academia - Vzdělávání',
      Body: 'Odborná literatura a materiály pro školení zaměstnanců a rozvoj',
      ApnsPriority: 10, Type: 0, Status: 0, Created: '2025-03-18T16:20:00Z',
      Transaction: {
        TransactionID: 1005, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Imported, SenderBusinessUnitName: 'Knihkupectví Academia',
        CreatedAt: '2025-03-18T16:20:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2041, foreignItemID: 141, requestNote: 'Knihy o agile development pro tým', responseNote: '', quantity: 2, proposedUnitPrice: 890.00, proposedTotal: 1780.00, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=300&h=200&fit=crop' },
          { itemID: 2042, foreignItemID: 142, requestNote: 'Leadership kniha pro manažery', responseNote: '', quantity: 1, proposedUnitPrice: 1200.50, proposedTotal: 1200.50, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop' },
          { itemID: 2043, foreignItemID: 143, requestNote: 'Kurz češtiny pro zahraniční kolegy', responseNote: 'Předschváleno - firemní benefit', quantity: 1, proposedUnitPrice: 700.00, proposedTotal: 700.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=300&h=200&fit=crop' }
        ]
      }
    },
    1006: {
      NotificationID: 1006, SenderUserID: 1, Title: 'Hotel Marriott - Služební cesta',
      Body: 'Ubytování během služební cesty - 2 noci, snídaně a konferenční služby',
      ApnsPriority: 10, Type: 0, Status: 3, Created: '2025-03-17T22:00:00Z',
      Transaction: {
        TransactionID: 1006, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Finished, SenderBusinessUnitName: 'Hotel Marriott',
        CreatedAt: '2025-03-17T22:00:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2051, foreignItemID: 151, requestNote: 'Ubytování během konference', responseNote: 'Schváleno - služební cesta', quantity: 2, proposedUnitPrice: 6500.00, proposedTotal: 13000.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=300&h=200&fit=crop' },
          { itemID: 2052, foreignItemID: 152, requestNote: 'Snídaně během pobytu', responseNote: 'Schváleno - standardní benefit', quantity: 4, proposedUnitPrice: 650.00, proposedTotal: 2600.00, status: ApproveItemStatus.Approved, imageUrl: 'https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?w=300&h=200&fit=crop' }
        ]
      }
    },
    1007: {
      NotificationID: 1007, SenderUserID: 1, Title: 'Benzina - Pohonné hmoty',
      Body: 'Tankování služebního vozidla - Natural 95, SPZ: 4A2 3456',
      ApnsPriority: 10, Type: 0, Status: 0, Created: '2025-03-17T07:45:00Z',
      Transaction: {
        TransactionID: 1007, RequestID: 0, ApprovedByUserID: 0, ForeignID: 0,
        Status: ApproveStatus.Imported, SenderBusinessUnitName: 'Benzina',
        CreatedAt: '2025-03-17T07:45:00Z', DocumentUpdated: [],
        Document: [
          { itemID: 2061, foreignItemID: 161, requestNote: 'Tankování služebního vozidla', responseNote: '', quantity: 50, proposedUnitPrice: 46.815, proposedTotal: 2340.75, status: ApproveItemStatus.None, imageUrl: 'https://images.unsplash.com/photo-1545262722-70d4d2b9c7ed?w=300&h=200&fit=crop' }
        ]
      }
    }
  };

  static getTransactionList(): Transaction[] {
    return [...this.mockTransactions];
  }

  static getTransactionDetail(transactionId: number): NotificationDetailDto | null {
    return this.mockTransactionDetails[transactionId] ? 
      { ...this.mockTransactionDetails[transactionId] } : null;
  }

  static updateTransactionStatus(transactionId: number, status: ApproveStatus): void {
    const transaction = this.mockTransactions.find(t => t.id === transactionId);
    if (transaction) {
      transaction.status = status;
    }
    
    const detail = this.mockTransactionDetails[transactionId];
    if (detail) {
      detail.Transaction.Status = status;
    }
  }

  static updateItemStatuses(transactionId: number, items: TransactionItem[]): void {
    const detail = this.mockTransactionDetails[transactionId];
    if (detail) {
      detail.Transaction.Document = [...items];
      
      const allApproved = items.every(item => item.status === ApproveItemStatus.Approved);
      if (allApproved) {
        this.updateTransactionStatus(transactionId, ApproveStatus.Finished);
      }
    }
  }

  static addMockTransaction(transaction: Transaction): void {
    this.mockTransactions.push(transaction);
  }

  static resetData(): void {
    this.mockTransactions.forEach(tx => {
      if (tx.id === 1001 || tx.id === 1003 || tx.id === 1005 || tx.id === 1007) {
        tx.status = ApproveStatus.Imported;
      } else {
        tx.status = ApproveStatus.Finished;
      }
    });
    
    Object.values(this.mockTransactionDetails).forEach(detail => {
      detail.Transaction.Document.forEach(item => {
        if (item.foreignItemID % 3 === 1) {
          item.status = ApproveItemStatus.Pending;
        } else if (item.foreignItemID % 3 === 2) {
          item.status = ApproveItemStatus.Approved;
        } else {
          item.status = ApproveItemStatus.Pending;
        }
      });
    });
  }
}
